import { environment } from '../../../environments/environment';

export let settings = {
    // host: 'http://127.0.0.1:8000/v1/' //local
    host: environment.baseAPIUrl + '/' //online
};
